import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import LearningSection from './components/LearningSection';
import MentorSection from './components/MentorSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  const [showModal, setShowModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [showModal]);

  const openModal = () => { setShowModal(true); setSubmitted(false); };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const nombreInput = form.querySelector<HTMLInputElement>('input[name="nombre"]');
    const emailInput = form.querySelector<HTMLInputElement>('input[name="email"]');
    const nombre = nombreInput?.value?.trim() ?? '';
    const email = emailInput?.value?.trim() ?? '';
    if (!nombre || !email) return;
    setSubmitting(true);
    try {
      const res = await fetch("https://cashexpress-f.esaullorenzo.es/captura_lead.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nombre, email }),
      });
      if (res.ok) {
        setSubmitting(false);
        setSubmitted(true);
        setTimeout(() => {
          window.open('https://chat.whatsapp.com/D1ddDVG4KWTK9K7vPP9RsZ?mode=gi_t', '_blank');
          setShowModal(false);
        }, 3000);
      } else {
        setSubmitting(false);
        alert("Error en el registro. Intenta de nuevo.");
      }
    } catch (_) {
      setSubmitting(false);
      alert("Error de conexión. Revisa tu internet.");
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <HeroSection onOpenModal={openModal} />
      <LearningSection onOpenModal={openModal} />
      <MentorSection />
      <CTASection onOpenModal={openModal} />
      <Footer />

      {/* MODAL POPUP COMPARTIDO */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.75)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowModal(false); }}
        >
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative overflow-hidden mx-2">
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-5 py-4 sm:px-6 sm:py-5 text-center">
              <div className="text-2xl mb-1">🎓</div>
              <h2 className="text-white text-lg sm:text-xl font-extrabold uppercase leading-tight">
                ¡Reserva tu cupo GRATIS!
              </h2>
              <p className="text-green-100 text-xs sm:text-sm mt-1">Clase en vivo — Cupos muy limitados</p>
            </div>

            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>

            <div className="px-5 py-5 sm:px-6 sm:py-6">
              {submitted ? (
                <div className="text-center py-6 sm:py-8">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                    <i className="ri-whatsapp-line text-3xl sm:text-4xl text-green-500"></i>
                  </div>
                  <h3 className="text-gray-800 text-lg sm:text-xl font-extrabold mb-2">
                    ¡Registro exitoso! 🎉
                  </h3>
                  <div className="bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-4 mb-5">
                    <p className="text-emerald-700 text-sm sm:text-base font-semibold leading-relaxed">
                      Te estamos direccionando al grupo de WhatsApp...
                    </p>
                    <div className="flex items-center justify-center gap-2 mt-3">
                      <span className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                      <span className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                      <span className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-xs mb-4">
                    Si no abre automáticamente, haz clic aquí:
                  </p>
                  <a
                    href="https://chat.whatsapp.com/D1ddDVG4KWTK9K7vPP9RsZ?mode=gi_t"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white px-6 py-3 rounded-full font-bold text-sm transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    Ir al grupo de WhatsApp
                  </a>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-gray-700 text-sm font-semibold mb-1">
                      Nombre completo <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="nombre"
                      required
                      placeholder="Ej: Juan Pérez"
                      className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 transition"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-semibold mb-1">
                      Correo electrónico <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="tucorreo@email.com"
                      className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 transition"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-4 rounded-full font-bold text-sm uppercase shadow-lg hover:scale-105 transition-transform disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
                  >
                    {submitting ? (
                      <span className="flex items-center justify-center gap-2">
                        <i className="ri-loader-4-line animate-spin"></i> Enviando...
                      </span>
                    ) : (
                      '🎯 CONFIRMAR MI CUPO GRATIS'
                    )}
                  </button>
                  <p className="text-center text-gray-400 text-xs">
                    🔒 Tu información está 100% segura. Sin spam.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
